









































































































import { Vue, Component } from 'vue-property-decorator';
import { Button, Dialog, Toast, Popup, List } from 'vant';
import * as config from './config';
import { isWeiXin } from '@/common/ts/common';
import { voteListUser, deleteUser, WinningList } from './api/index';
Vue.use(Popup)
  .use(Dialog)
  .use(Toast)
  .use(Button)
  .use(List);
@Component({
  components: {},
})
export default class User extends Vue {
  option = config.OPTHINES;
  userList = [];
  List: any[] = [];
  createDate: any[] = [];
  showUserList = true;
  pointOut = false;
  loading = false;
  finished = false;
  page = 1;
  noList = false;
  get source() {
    return this.$route.params.source;
  }
  async created() {
    // 登录成功后回调
    window.userInfoChange = () => {
      this.$router.go(0);
    };
    // if (!window.udid) {
    if (isWeiXin()) {
      Dialog.confirm({
        title: '友情提示',
        message: '请在上游新闻App进行查看',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        overlay: true,
        closeOnClickOverlay: false,
      })
        .then(() => {
          window.location.href =
            'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
        })
        .catch(() => {
          if (isWeiXin() === true) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
    }
    // const res = await voteListUser();
    // this.successGetUser(res);
    if (window.gettoken() !== '' && window.gettoken() !== 'null') {
      this.showUserList = false;
    } else {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
    }
  }
  public onLoad() {
    WinningList(this.page).then((res: any) => {
      this.endListData(res);
    });
  }
  public endListData(res: any) {
    // console.log('res.data', res.data, this.page);
    if (this.page === 1 && res.data === '') {
      this.noList = true;
    }
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.List = [...this.List, ...res.data];
      this.page = this.page + 1;
    }
    this.loading = false;
  }
  public successWinningList(res: any) {
    console.log('res', res);
    this.List = res.data;
  }
  public successGetUser(res: any) {
    console.log(res.code);
    switch (res.code) {
      case 203:
        this.showUserList = false;
        if (!window.udid) {
          // if (isWeiXin()) {
          Dialog.confirm({
            title: '友情提示',
            message: '请在上游新闻App进行查看',
            confirmButtonText: '还没装？一步安装',
            cancelButtonText: '我已安装过',
            overlay: true,
            closeOnClickOverlay: false,
          })
            .then(() => {
              window.location.href =
                'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
            })
            .catch(() => {
              if (isWeiXin() === true) {
                this.pointOut = true;
              } else {
                window.location.href =
                  'shangyounews://{"dt":"7","url":"' +
                  document.location.href +
                  '"}';
              }
            });
        } else if (parseFloat(window.version) >= 4.5) {
          window.handleMessage('{"action":"mUserLogin","data":""}');
        } else {
          window.location.href = 'client:logout';
        }
        break;
      case 200:
        console.log('res.data', res.data);
        this.userList = res.data;
        if (res.data.length === 0) {
          this.showUserList = false;
        } else {
          // 时间格式转换
          for (const timeItem of res.data) {
            const date = new Date();
            date.setTime(timeItem.createtime * 1000);
            // const year = date.getYear();
            const month = date.getMonth() + 1;
            const d = date.getDate();
            this.createDate.push(month + '-' + d);
          }
        }
    }
  }
  public handleDel(id: any) {
    Dialog.confirm({
      title: '提示',
      message: '你确定要删除吗？',
    })
      .then(() => {
        deleteUser({ id }).then((res) => this.successDelete(res));
      })
      .catch(() => {
        console.log('取消删除');
      });
  }
  // 删除成功
  public successDelete(res: any) {
    if (res.code === 200) {
      Toast('删除成功！');
      setTimeout(() => {
        this.$router.go(0);
      }, 1000);
    }
  }
  public enterUploading() {
    if (isWeiXin()) {
      Dialog.confirm({
        title: '友情提示',
        message: '请在上游新闻App进行查看',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        overlay: true,
        closeOnClickOverlay: false,
      })
        .then(() => {
          window.location.href =
            'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
        })
        .catch(() => {
          if (isWeiXin() === true) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
    } else if (parseFloat(window.version) >= 4.5) {
      window.handleMessage('{"action":"mUserLogin","data":""}');
    } else {
      window.location.href = 'client:logout';
    }
    // 判断用户是否登录
    // if (window.gettoken() !== '' && window.gettoken() !== 'null') {
    //   this.$router.push({ path: './Uploading' });
    // } else {
    //   if (parseFloat(window.version) >= 4.5) {
    //     window.handleMessage('{"action":"mUserLogin","data":""}');
    //   } else {
    //     window.location.href = 'client:logout';
    //   }
    // }
  }
  public enterDetail(item: any) {
    if (item.enable === '2') {
      Dialog({ message: '未审核通过，请上传符合要求的作品' });
    } else {
      this.$router.push({
        path: './Detail',
        query: { id: item.id, type: item.work_type, source: this.source },
      });
    }
  }
}
